<template>
    <div>
        <b-modal
            id="finding_form_modal"
            hide-footer
            v-model="findingModal.show"
        >
            <template #modal-title>
                {{ item.monitoring_type }} - [ ITEM {{ item.code }} ] {{ item.id_hallazgo }}
            </template>

            <b-row>
                <b-col sm="12" lg="12">
                    <b-form-group
                        id="observation"
                        label="CUMPLE"
                    >
                    <el-select v-model="item.cumple">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" lg="12" v-if="item.cumple === 0 || item.cumple === 2">
                    <b-form-group
                        id="observation"
                        label="OBSERVACIONES"
                    >
                        <b-textarea
                            rows="5"
                            class="form-control"
                            v-model="item.observaciones"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" lg="12" v-if="item.cumple === 0 || item.cumple === 2">
                    <b-form-group
                        id="improvement"
                        label="OPORTUNIDAD DE MEJORA"
                    >
                        <b-textarea
                            rows="5"
                            class="form-control"
                            v-model="item.opciones_mejora"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" lg="12">
                    <b-form-group
                        id="legislation"
                        label="LEGISLACIÓN"
                    >
                        <b-textarea
                            rows="5"
                            class="form-control"
                            v-model="item.legislacion"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" lg="12">
                    <b-form-group
                        id="area"
                        label="ÁREA"
                    >
                        <b-textarea
                            rows="5"
                            class="form-control"
                            v-model="item.ubicacion"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="12" class="text-center">
                    <hr />
                    <b-button variant="secondary mr-2" size="sm" @click="closedFindingModal()">
                        Cerrar
                    </b-button>
                    <b-button variant="primary" size="sm" @click="saveItem()">
                        Agregar
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    name: "FindingForm",
    data() {
        return {
            options:[
                {
                    label: 'SI',
                    value: 1
                },
                {
                    label: 'NM',
                    value: 2
                },
                {
                    label: 'NO',
                    value: 0
                },
                {
                    label: 'NA',
                    value: 9
                },
            ]
        }
    },
    computed: {
        ...mapState("hallazgo", ["findingModal","item"]),
        ...mapState('listaChequeo', ['listaTipoSeguimientos'])
    },
    methods: {
        closedFindingModal(){
            this.closeFindingModal();
        },
        saveItem(){
            this.saveFindings({...this.item, geneteError:true})
            .then(()=>{
                const monitoring = this.listaTipoSeguimientos.find(e => e.id===this.item.monitoring_type_id);
                const item = monitoring.items.find(e => e.id === this.item.id);
                item.cumple = this.item.cumple;
                item.observaciones = this.item.observaciones;
                item.opciones_mejora = this.item.opciones_mejora;
                item.legislacion = this.item.legislacion;
                item.ubicacion = this.item.ubicacion;
                this.closeFindingModal();
            })
            .catch((error)=>this.$alertError(error.message));
        },
        ...mapActions("hallazgo",['closeFindingModal','saveFindings'])
    }
}
</script>
